import React from "react";
import Header from "../Header";
import { Link } from "react-router-dom";

function Service(props) {
  return (
    <div>
      <Header />
      <div>
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/Carstationary"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/catalogue12.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Stationery
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Get readymade stationery
                </p>
              </div>
            </Link>

            <Link
              to="https://youtube.com/shorts/Fo6qyiTd8q4?si=LiMNM2k_Ho2YqPBC"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>
        {/* 2 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/Updatedcarprice"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/car-unsold12.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  New pricelist
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Get updated pricelist
                </p>
              </div>
            </Link>

            <Link
              to="https://youtube.com/shorts/9Rs1N0sPu_s?si=G9vNE8re4OWv0nFI"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>

        {/* 3 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/CheckRC"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/information12.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Car Info
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Get vehicle details by RC Number
                </p>
              </div>
            </Link>
            <Link
              to="https://www.youtube.com/shorts/ULmO1TpdUa8"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>

        {/* 4 1 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="https://echallan.parivahan.nic.in/challan"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/challan.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Check Challan
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Check court challan only
                </p>
              </div>
            </Link>
            <Link
              to="https://www.youtube.com/shorts/K43ford1oBE"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>
        {/* 4 */}
        {/* <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="https://echallan.parivahan.nic.in/challan"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/challan.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Check Challan
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Check court challan only
                </p>
              </div>
            </Link>
          </div>
        </div> */}

        {/* 5 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/SearchmoreCars"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/trade12.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Dealer Market
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Search vehicle from Dealers
                </p>
              </div>
            </Link>

            <Link
              to="https://youtube.com/shorts/SklRYPIYTQI?si=noDJX8n6stxAWao-"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>

        {/* 5 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/LoanEmi"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/calculator12.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  EMI Calculator
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Calculate EMI for your vehicle
                </p>
              </div>
            </Link>{" "}
            <Link
              to="https://www.youtube.com/shorts/SFjltt2sJeE"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>
        {/* 6 */}
        <div className="dash-block p-2 m-2">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link
              to="/MessageTemplate"
              className="totalcar"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <img src="assets/images/template.png" alt="" />
              <div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#333333",
                    // padding: "0 0 0 20px",
                    display: "block",
                  }}
                  className="m-0"
                >
                  Message Templates
                </span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#ff0000",
                    display: "block",
                    margin: "0",
                    // padding: "0 0 0 20px",
                  }}
                >
                  Get readymade messages
                </p>
              </div>
            </Link>
            <Link
              to="https://www.youtube.com/shorts/PmgzWf7pV9Q"
              target="_blank"
            >
              <img
                src="assets/images/video.png"
                className="ms-3"
                height={30}
                alt=""
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Service;

// old
// import React from "react";
// import Header from "../Header";
// import { Link } from "react-router-dom";

// function Service(props) {
//   return (
//     <div>
//       <Header />
//       <div>
//         <div className="dash-block m-2">
//           <>
//             <Link to="/Carstationary">Stationery</Link>
//             <Link
//               to="https://youtube.com/shorts/Fo6qyiTd8q4?si=LiMNM2k_Ho2YqPBC"
//               target="_blank"
//             >
//               <img
//                 src="assets/images/video.png"
//                 className="ms-3"
//                 height={30}
//                 alt=""
//               />
//             </Link>
//             <Link
//               to="/Carstationary"
//               className="d-flex justify-content-between align-items-center totalcar"
//             >
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Get readymade stationery
//               </h3>
//               <img src="assets/images/catalogue12.png" alt="" />
//             </Link>
//           </>
//         </div>
//         <div className="dash-block m-2">
//           <>
//             <Link to="/Updatedcarprice">New pricelist</Link>
//             <Link
//               to="https://youtube.com/shorts/9Rs1N0sPu_s?si=G9vNE8re4OWv0nFI"
//               target="_blank"
//             >
//               <img
//                 src="assets/images/video.png"
//                 className="ms-3"
//                 height={30}
//                 alt=""
//               />
//             </Link>
//             <Link
//               to="/Updatedcarprice"
//               className="d-flex justify-content-between align-items-center totalcar"
//             >
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Get updated pricelist
//               </h3>
//               <img src="assets/images/car-unsold12.png" alt="" />
//             </Link>
//           </>
//         </div>

//         <div className="dash-block m-2">
//           <Link to="/CheckRC">
//             <span>RTO information</span>
//             <div className="d-flex justify-content-between align-items-center totalcar">
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Get vehicle details by RC Number
//               </h3>
//               <img src="assets/images/information12.png" alt="" />
//             </div>
//           </Link>
//         </div>

//         <div className="dash-block m-2">
//           <Link to="https://echallan.parivahan.nic.in/challan">
//             <span>Check Challan</span>
//             <div className="d-flex justify-content-between align-items-center totalcar">
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Check court challan only
//               </h3>
//               <img src="assets/images/challan.png" alt="" />
//             </div>
//           </Link>
//         </div>

//         {/* <div className="dash-block m-2">
//           <Link to="/SearchmoreCars">
//             <span>Dealer Market</span>
//             <div className="d-flex justify-content-between align-items-center totalcar">
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Search vehicle from Dealers
//               </h3>
//               <img src="assets/images/trade12.png" alt="" />
//             </div>
//           </Link>
//         </div> */}
//         <div className="dash-block m-2">
//           <>
//             <Link to="/SearchmoreCars">Dealer Market</Link>{" "}
//             <Link
//               to="https://youtube.com/shorts/SklRYPIYTQI?si=noDJX8n6stxAWao-"
//               target="_blank"
//             >
//               <img
//                 src="assets/images/video.png"
//                 className="ms-3"
//                 height={30}
//                 alt=""
//               />
//             </Link>
//             <Link
//               to="/SearchmoreCars"
//               className="d-flex justify-content-between align-items-center totalcar"
//             >
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Search vehicle from Dealers
//               </h3>
//               <img src="assets/images/trade12.png" alt="" />
//             </Link>
//           </>
//         </div>
//         <div className="dash-block m-2">
//           <Link to="/LoanEmi">
//             <span>EMI Calculator</span>
//             <div className="d-flex justify-content-between align-items-center totalcar">
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Calculate EMI for your vehicle
//               </h3>
//               <img src="assets/images/calculator12.png" alt="" />
//             </div>
//           </Link>
//         </div>
//         <div className="dash-block m-2">
//           <Link to="/MessageTemplate">
//             <span>Message Templates</span>
//             <div className="d-flex justify-content-between align-items-center totalcar">
//               <h3 style={{ fontSize: "14px", lineHeight: "14px" }}>
//                 Get readymade messages
//               </h3>
//               <img src="assets/images/template.png" alt="" />
//             </div>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Service;
